import { render, staticRenderFns } from "./ArquivoCancelado.vue?vue&type=template&id=098221fc&scoped=true"
import script from "./ArquivoCancelado.vue?vue&type=script&lang=js"
export * from "./ArquivoCancelado.vue?vue&type=script&lang=js"
import style0 from "./ArquivoCancelado.vue?vue&type=style&index=0&id=098221fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098221fc",
  null
  
)

export default component.exports